import { Box, Typography, useTheme } from "@mui/material";
import { useContext } from "react";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import CopyButton from "@/modules/common/components/ui/copy-button";

const LeadIdField = () => {
  const { lead } = useContext(LeadPageContext);
  const theme = useTheme();

  const leadId = lead?.data?.nanoId;

  if (!leadId) {
    return (
      <Typography
        sx={{
          ...theme.nawy.typography.english.variants.body.md.regular,
          color: theme.nawy.colors.semantic.text.tertiary,
        }}
      >
        Not set
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: theme.nawy.spacing.xxs,
      }}
    >
      <Typography
        sx={{
          ...theme.nawy.typography.english.variants.body.md.regular,
          color: theme.nawy.colors.semantic.text.primary,
        }}
      >
        {leadId}
      </Typography>
      <CopyButton
        text={leadId}
        color={theme.nawy.colors.semantic.text.accent}
        size={16}
      />
    </Box>
  );
};

export default LeadIdField;
